module.exports = __webpack_public_path__ + "img/Screenshot_8.9707ebf9.png";